import { AuthService, Logger } from '@indigo-ag/ui-core';
import { GraphQLError } from 'graphql';

import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

const logout = () => {
  AuthService.clearTokens();
  window.location.href = '/';
  window.location.reload();
};

const hasErrorCode = (code: string) => {
  return (error: GraphQLError) => (error.extensions ? error.extensions.code === code : false);
};

export const getErrorLink = (): ApolloLink => {
  return onError(({ graphQLErrors, networkError, response, operation }): void => {
    const request = {
      name: operation.operationName,
      body: operation.query.loc && operation.query.loc.source.body,
      variables: operation.variables
    };

    if (graphQLErrors) {
      graphQLErrors.map(error => Logger.error(`[GraphQL error]: Message: ${error.message}`, { request, error }));

      // Check for Unauthorized error in error array
      const foundUnauthorizedError = graphQLErrors.find(hasErrorCode('UNAUTHENTICATED'));
      if (foundUnauthorizedError) {
        Logger.info('Encountered a GraphQL unauthorized error.', { request, error: foundUnauthorizedError });
        logout();
      }
    }

    if (networkError) {
      // Check for Unauthorized error in status code
      if (
        (networkError as any).statusCode === 401 ||
        (networkError as any).status === 401 ||
        (networkError as any).name === 'UnauthorizedError'
      ) {
        Logger.info('Encountered a network 401 response.', networkError);
        logout();
      } else {
        Logger.info('Network Error', { request, error: networkError });
      }
    }
  });
};
